<div class="nt-main-container">
    <owc-card oneCard class="nt-one-card">
        <owc-component-header slot="header">
            <div style="font-weight:600">Notification Title </div>
        </owc-component-header>
        <div class="nt-input-section">
            <p>You can also create your own title</p>
            <owc-input [label]="'Add title (optional)'" style="width: 98%;" [formControl]="notificationTitleformctrl"
                value="" />
        </div>

    </owc-card>
</div>